import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getVoxRoiConfig,
  updateVoxRoiConfig,
  getVoxRoiCatalog,
  getVoxRoiUsage,
} from '../services/voxRoiService';
import {
  VoxRoiConfigRequest,
  VoxRoiConfigResponse,
  VoxProductCatalogItem,
  VoxRoiUsageResponse,
} from '../models/voxRoi';

export const useVoxRoiConfig = () => {
  return useQuery<VoxRoiConfigResponse | null>({
    queryKey: ['vox-roi-config'],
    queryFn: getVoxRoiConfig,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
};

export const useUpdateVoxRoiConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: VoxRoiConfigRequest) => updateVoxRoiConfig(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['vox-roi-config'] });
    },
  });
};

export const useVoxRoiCatalog = () => {
  return useQuery<VoxProductCatalogItem[]>({
    queryKey: ['vox-roi-catalog'],
    queryFn: getVoxRoiCatalog,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
};

export const useVoxRoiUsage = ({
  startDate,
  endDate,
  enabled = true,
}: {
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
}) => {
  return useQuery<VoxRoiUsageResponse>({
    queryKey: ['vox-roi-usage', startDate, endDate],
    queryFn: () => getVoxRoiUsage({ startDate: startDate!, endDate: endDate! }),
    enabled: enabled && !!startDate && !!endDate,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
};
